<div mat-dialog-title>
    Adjust Player Index - {{player.first}} {{player.last}}
  </div>
  <div>
      Any score that produces a Score Differential that is at least 7.0 strokes better than your Handicap Index at the time the round was played is considered exceptional and is subject to the Exceptional Score Reduction.
      <ul>
        <li>
            If the Score Differential is between 7.0 and 9.9 strokes better, a 1 stroke adjustment is applied to each of the most recent 20 Score Differentials in your scoring record. This has a net impact of reducing the Handicap Index by 1 stroke.
        </li>
        <li>
            If the Score Differential is 10.0 strokes or better, a 2 stroke adjustment is applied to each of the most recent 20 Score Differentials. This has a net impact of reducing the Handicap Index by 2 strokes.
        </li>
      </ul>
      Scores made following the exceptional score will not contain the 1 or 2 stroke adjustment (unless they are also exceptional) which will slowly diminish the impact of the reduction as you continue to post scores. Also, reductions for multiple exceptional scores are applied cumulatively. (Rule 5.9, Rules of Handicapping)
  </div>
  <br/>
  <hr/>
  <br/>
  <div fxLayout='row wrap' fxLayoutAlign='space-between center'>
      <mat-form-field>
          <mat-label>Adjustment</mat-label>
          <mat-select [(ngModel)]="adjustment" placeholder="Adjustment" required>
            <mat-option value="1">1</mat-option>
            <mat-option value="2">2</mat-option>
            </mat-select>
        </mat-form-field>
      <div fxLayout='row' fxLayoutAlign='start center'>
          <button mat-raised-button color='accent' [disabled]="adjusting" (click)='onOk()'>Process Score Adjustment</button>
          <button mat-button mat-dialog-close [disabled]="adjusting">Nevermind</button>
      </div>
  </div>
  <div *ngIf="adjusting" fxLayout="row" fxLayoutAlign="center center">
    <div class="accent-color">
        <i class="fa fa-spinner fa-spin"></i> Making Correction and adjusting future rounds ...
    </div>
  </div>